import React from 'react';
import { FormRadio, FormGroup, FormFeedback } from 'shards-react';
import { useTranslation } from 'react-i18next';
import './style.css';
const Radio = (props) => {
  const { inputHasErrors, label } = props;
  const { t, i18n } = useTranslation();

  return (
    <FormGroup>
      <FormRadio invalid={inputHasErrors} {...props}>
        {label && <span className="capitalize-first-letter margin-left-label">{label}</span>}
      </FormRadio>
      <FormFeedback invalid>{t(inputHasErrors)}</FormFeedback>
    </FormGroup>
  );
};

export default Radio;
